// extracted by mini-css-extract-plugin
export default {"general":"memberTable_general__FOhRj","form":"memberTable_form__b+Aba"};